import classNames from 'classnames'
import React, {PropsWithChildren} from 'react'
import s from './tickets-container.scss'

export const TicketsContainer = ({children, className}: PropsWithChildren<{className?: string}>) => {
  return <ul className={classNames(s.container, className)}>{children}</ul>
}
